import React from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import { connect } from "react-redux";
import { formatTitle } from "../../../utils/formatting";
import Arrangements from "./Tabs/Arrangements";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

const endPoint = "core/zones";

function ZoneForm(props) {
  const { vestiging } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"zones"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.zoneName);
        }}
        endPoint={endPoint}
        extraFields={{ vestiging_id: props.vestiging_id }}
        pageTitle={getTranslation("zones.form.pageTitle", "Zone")}
        rootRight={"zones"}
        tabs={(model) => {
          return [
            {
              right: "algemeen",
              tabButton: <TranslationWrapper tDefault={"General"} tKey={"zones.form.tabs.algemeen"} />,
              tabContent: <Algemeen />,
            },
            ...(model?.vestiging?.use_arrangements
              ? [
                  {
                    right: "algemeen",
                    tabButton: <TranslationWrapper tDefault={"Arrangements"} tKey={"Arrangements"} />,
                    tabContent: <Arrangements />,
                  },
                ]
              : []),
          ];
        }}
      />
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(ZoneForm);
